if (!customElements.get('before-after-slider')) {
  customElements.define(
    'before-after-slider',
    class BeforeAfterSlider extends HTMLElement {
      connectedCallback() {
        this.initSlider();
      }

      disconnectedCallback() {
        if (this.range) {
          this.range.removeEventListener('input', this.onInput);
          this.range.removeEventListener('change', this.onInput);
        }
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      initSlider() {
        this.range = this.querySelector('.before-after__range');
        this.before = this.querySelector('[data-before-layer]');
        this.handle = this.querySelector('[data-handle]');
        if (!this.range || !this.before) return;

        this.range.removeEventListener('input', this.onInput);
        this.range.removeEventListener('change', this.onInput);

        this.updateFrameWidth();
        this.setPosition(this.range.value);
        this.range.addEventListener('input', this.onInput);
        this.range.addEventListener('change', this.onInput);

        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.resizeObserver = new ResizeObserver(() => this.updateFrameWidth());
        this.resizeObserver.observe(this);
      }

      updateFrameWidth() {
        this.style.setProperty('--ba-frame-width', `${this.offsetWidth}px`);
      }

      onInput = (event) => {
        this.setPosition(event.target.value);
      };

      setPosition(value) {
        const percent = Math.min(100, Math.max(0, Number(value)));
        this.before.style.width = `${percent}%`;
        if (this.handle) this.handle.style.left = `${percent}%`;
        this.range.setAttribute('aria-valuenow', String(Math.round(percent)));
      }
    }
  );
}

document.addEventListener('shopify:section:load', (event) => {
  const section = document.getElementById(`shopify-section-${event.detail?.sectionId || ''}`);
  if (!section) return;
  section.querySelectorAll('before-after-slider').forEach((slider) => {
    if (typeof slider.initSlider === 'function') slider.initSlider();
  });
});
